import RightArrow from './RightArrow';

const LeftArrow = ({ className = 'stroke-bgSecondary' }: { className?: string }) => (
  <RightArrow className={`${className} rotate-180 transform`} />
);

export default LeftArrow;
